/**
 * A success-fee rate, written the way the reader's language writes a percentage.
 *
 * The API sends basis points because that is the unit the fee is billed in, and
 * an operator can set a rate that is not a whole percent, so the conversion and
 * the decimal both live here rather than being open-coded next to a card.
 *
 * The locale decides the separator and the space before the sign: French puts a
 * non-breaking one there, English none at all, and neither is our call to make.
 */
export function formatSuccessFeeRate(basisPoints: number, locale: string): string {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'percent',
      minimumFractionDigits: 0,
      // A basis point is a hundredth of a percent, so two decimals is the
      // finest rate that can exist rather than an arbitrary precision.
      maximumFractionDigits: 2,
    }).format(basisPoints / 10_000);
  } catch {
    // The locale arrives from a translation file and `Intl` throws on one it
    // does not know. A rate written plainly beats a pricing page that crashes.
    return `${basisPoints / 100}%`;
  }
}
